/** ラベル左・入力右レイアウト用の共通設定 */
export const INTAKE_LABEL_WIDTH = { xs: '6rem', sm: '8rem' } as const;

/** hiddenLabel 時の Outlined 枠線ノッチを閉じる（左上の線が途切れないようにする） */
export const intakeOutlinedNotchSx = {
  '& .MuiOutlinedInput-notchedOutline legend': {
    width: 0,
    maxWidth: 0,
    fontSize: 0,
  },
  '& .MuiOutlinedInput-notchedOutline legend span': {
    paddingLeft: 0,
    paddingRight: 0,
  },
} as const;

/** 入力欄を縦にコンパクトにする（1画面に多くの項目を収める） */
export const intakeCompactInputSx = {
  ...intakeOutlinedNotchSx,
  '& .MuiInputBase-root': {
    minHeight: 32,
  },
  '& .MuiInputBase-input': {
    py: 0.5,
    fontSize: '0.8125rem',
    '&::placeholder': {
      fontSize: '0.75rem',
      opacity: 0.55,
    },
  },
  '& .MuiInputBase-inputMultiline': {
    fontSize: '0.8125rem',
    '&::placeholder': {
      fontSize: '0.75rem',
      opacity: 0.55,
    },
  },
  '& .MuiFormHelperText-root': {
    mt: 0.25,
    mx: 0,
    lineHeight: 1.3,
  },
} as const;

export const intakeFieldSlot = {
  fullWidth: true,
  size: 'small' as const,
  margin: 'dense' as const,
  hiddenLabel: true,
  sx: intakeCompactInputSx,
} as const;

/** 患者情報画面の対応ステータス・対応期日など横並びコントロールの高さ */
export const PATIENT_DETAIL_CONTROL_HEIGHT = 32;

export const patientDetailLabelRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  mb: 0.5,
  minHeight: 20,
} as const;

export const patientDetailControlRowSx = {
  minHeight: PATIENT_DETAIL_CONTROL_HEIGHT,
  height: PATIENT_DETAIL_CONTROL_HEIGHT,
  display: 'flex',
  alignItems: 'center',
} as const;

export const patientDetailToggleGroupSx = {
  flexWrap: 'wrap',
  '& .MuiToggleButton-root': {
    px: 1.5,
    py: 0,
    lineHeight: 1.43,
    minHeight: PATIENT_DETAIL_CONTROL_HEIGHT,
    height: PATIENT_DETAIL_CONTROL_HEIGHT,
  },
} as const;

export const patientDetailDateFieldSx = {
  ...intakeCompactInputSx,
  m: 0,
  '& .MuiInputBase-root': {
    height: PATIENT_DETAIL_CONTROL_HEIGHT,
    minHeight: PATIENT_DETAIL_CONTROL_HEIGHT,
  },
  '& .MuiInputBase-input': {
    py: 0,
    boxSizing: 'border-box',
  },
} as const;

/** 患者受付・詳細のページ幅（Grid spacing の負マージン + スクロールバー分の右余白） */
export const intakePageMaxWidthSx = {
  maxWidth: 1400,
  mx: 'auto',
  width: '100%',
  boxSizing: 'border-box',
  pr: { xs: 1.5, md: 1.25, lg: 1.25, xl: 1 },
} as const;
